import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { magicTodo } from "../../functions/aiService/chatGPTService";
import { aiTasksToFirebaseAction } from "../../redux/actions/TodoManipulation/aiTasksToFirebaseAction";
import { setAiTasks } from "../../redux/actions/setAiTasksAction";

const AiModalComponent = (props) => {
    const { modalOpen, onClose, todoTitle, parentId, newTodo, addTodo } = props;
    const [aiResponse, setAiResponse] = useState("");
    const [message, setMessage] = useState("");
    const [checkSelectAll, setCheckSelectAll] = useState(true);
    const [disableFinishButton, setDisableFinishButton] = useState(true);
    const [aiError, setAiError] = useState(null);
    const [responseLoading,setResponseLoading]=useState(false);
    const ref = useRef();
    const dispatch = useDispatch();
    let error = false;
    const handleAddProject = async () => {

        // Check we've at least one task selected
        let selected = false;
        for (let t = 0; t < aiResponse.tasks.length; t++) {
            if (aiResponse.tasks[t].selected) {
                selected = true;
                break;
            }
        }

        if (!selected) {
            error = true;
            return;
        }

        let subTasks = [];
        for (let t = 0; t < aiResponse.tasks.length; t++){
            if (aiResponse.tasks[t].selected) {
                subTasks.push(aiResponse.tasks[t].title);
            }
        }

        if (addTodo) {
            dispatch(setAiTasks(subTasks));
        } else {
            // Assign a blank GUID if parent is null
            let parentID = parentId ?? '00000000-0000-0000-0000-000000000000';

            const json = {
                parentId: parentID,
                todoTitle: todoTitle,
                subTaskTitles: subTasks,
                newTodo: newTodo
            };

            await dispatch(aiTasksToFirebaseAction(json));
        }
        setAiResponse("");
        setMessage("");
        handleClose();
    };
    useEffect(() => {
        if (modalOpen) {
            ref.current?.showModal();
        } else {
            ref.current?.close();
        }

        setMessage(todoTitle);
        setAiResponse("");
        setDisableFinishButton(true);
        setAiError(false);
    }, [modalOpen]);


    const generateAiTaskList = async (message) => {
        if (!message) return;
        setAiError(false);
        setResponseLoading(true);

        try {
            let responseList = await magicTodo(message);

            if (responseList && responseList.tasks) {
                if (typeof responseList === "object") {
                    responseList = JSON.stringify(responseList);
                }

                const parsedResponse = JSON.parse(responseList);

                if (parsedResponse.tasks.length === 1 &&
                    parsedResponse.tasks[0].title === "cannot be broken down") {
                    setAiError("Task cannot be broken down. Please provide more information.");
                    setResponseLoading(false);
                    return;
                }

                if (parsedResponse.tasks.length > 0) {
                    setDisableFinishButton(false);
                }

                for (let i = 0; i < parsedResponse.tasks.length; i++) {
                    parsedResponse.tasks[i].selected = true;
                }

                setAiResponse(parsedResponse);
                setCheckSelectAll(true);
            } else {
                setAiError(responseList?.message || "Problem occurred while retrieving tasks. Please try again.");
                console.error(`Error: ${responseList?.message || "An unknown error occurred."}`);
            }
        } catch (error) {
            setAiError(error.message);
        } finally {
            setResponseLoading(false);
        }
    };


    const handleTaskCheckStatus = (event, index) => {

        const updatedTasks = [...aiResponse.tasks]; 
        updatedTasks[index].selected = event.target.checked; 
        setAiResponse({ ...aiResponse, tasks: updatedTasks });

        const count = updatedTasks.some(item => item.selected === true);

        if (count > 0) {
            setDisableFinishButton(false);
        } else {
            setDisableFinishButton(true);
        }
    }

    const handleClose = () => {
        onClose();
    };

    const handleSelectAll = (event) => {

        const updatedTasks = [...aiResponse.tasks]

        for (let i = 0; i < updatedTasks.length; i++) {
            updatedTasks[i].selected = event.target.checked;
        }

        setAiResponse({ ...aiResponse, tasks: updatedTasks });
        setCheckSelectAll(event.target.checked);
    };

    return (
        <dialog className="gt-modal gt-modal--task"
            aria-labelledby="break-it-down-title"
            ref={ref}>
            <div className="gt-break-it-down">
                <div className="gt-break-it-down__heading">
                    <div className="gw-group">
                        <button type="button" aria-label="Go back" className="gw-icon-button"
                            onClick={handleClose}
                        >
                            <i className="gw-icon-button__icon gw-button__icon--chevron-left"></i>
                        </button>
                        <h1 id="break-it-down-title">Help me break this down</h1>
                    </div>
                    <p>We will break down the task into manageable steps. Describe below what you want to create task items for.</p>
                    <div className="gw-form-fieldset-item">
                        <label className="gw-form-fieldset-item__label sr-only" placeholder="what-to-breakdown">What would you like to create a task for?</label>
                        <input type="text" className="gw-input" placeholder="What would like to breakdown?" id="what-to-breakdown"
                            value={message} onChange={(e) => setMessage(e.target.value)} />
                        <button type="button" className="gw-button gw-button--secondary"
                            onClick={() => generateAiTaskList(message)}
                        >
                            Generate
                        </button>
                    </div>
                    {aiError && (<div className="error-body" style={{textAlign: "left"} }>
                        <label className="gw-checkbox__input-label error-message"
                            style={{ color: "red" }}>
                            { aiError}
                        </label>
                    </div>)}
                </div>
                <div className="gt-break-it-down__body">
                    {responseLoading && <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                        <svg className="gw-round-spinner" viewBox="25 25 50 50" style={{ width: '100px', height: '100px' }}>
                            <circle cx="50" cy="50" r="20" />
                        </svg>
                    </div>}
                    {aiResponse && (
                        <ul> 
                            <li key="selectAll"
                                style={{display: "none"} }>
                                <p>Select all:</p>
                                <div className="gw-checkbox">
                                    <input id="select-all" type="checkbox" className="gw-checkbox__input"
                                        checked={checkSelectAll}
                                        onChange={handleSelectAll}
                                    />
                                        <label htmlFor="select-all" className="gw-checkbox__input-label sr-only">Select all</label>
                                </div>
                            </li>
                                {aiResponse.tasks.map((task, index) => (
                            <li key={index}>
                                <div className="gt-task">
                                    <div className="gt-task__color" style={{ background: '#80C3E9' }}></div>
                                    <input className="gt-task__completed" type="checkbox" aria-label="Task completed?"/>
                                    <p className="gt-task__title">{task.title}</p>
                                    <button className="gw-icon-button gw-icon-button--icon" aria-label="more">
                                        <i className="gw-icon-button__icon gw-button__icon--more"></i>
                                    </button>
                                </div>
                                <div className="gw-checkbox">
                                    <input type="checkbox" className="gw-checkbox__input"
                                                id={index}
                                                defaultChecked={true}
                                        checked={aiResponse.tasks.selected}
                                        onChange={(event) => handleTaskCheckStatus(event, index)}
                                    />
                                    <label htmlFor="select-task-1" className="gw-checkbox__input-label sr-only">Select all</label>
                                </div>
                            </li>
                            ))}
                        </ul>
                    )}
                </div>
                <div className="gt-break-it-down__footer">
                    <div className="gw-group">
                        <p>Adding to task:</p>
                        <p><b>{todoTitle}</b></p>
                    </div>
                    {error && (
                        <div className="error-body">
                            <label className="gw-checkbox__input-label error-message">
                                Please add a Task title.
                            </label>
                        </div>
                    )}
                    <button type="button" className="gw-button gw-button--s3 gw-button--primary"
                        onClick={handleAddProject}
                        disabled={disableFinishButton}
                    >
                        Finish and add
                    </button>
                </div>
            </div>
        </dialog>
    );
};

export default AiModalComponent;
